import _Object$keys from '/app/node_modules/babel-runtime/core-js/object/keys';
import moment from 'moment';
import leftPad from 'left-pad';
import { settingsConfig } from '~~/config/settings';
import { addressTypeEnum, subProductEnum, virtualPosEnum, contactTypeEnum, currencyTypeEnum } from '../enums';
import { mapToVirtualValue } from './virtual-transform-data';

export var mapRequestVirtualAffiliation = function mapRequestVirtualAffiliation(form, username) {
    var rucValidation = form.rucValidation,
        virtual = form.virtual,
        legalRepresentativeData = form.legalRepresentativeData,
        paymentData = form.paymentData;
    var pos = form.posSelected.pos;
    var _form$businessData = form.businessData,
        commerceData = _form$businessData.commerceData,
        administrativeAddress = _form$businessData.administrativeAddress,
        commercialAddress = _form$businessData.commercialAddress;
    var _form$businessSchedul = form.businessSchedule,
        startTime = _form$businessSchedul.startTime,
        endTime = _form$businessSchedul.endTime;

    var Moneda = paymentData.currencyType;
    var MCCI = Number(commerceData.commercialBusiness.Code);
    var bankName = void 0,
        accountNumber = void 0,
        accountType = void 0;

    if (Moneda === currencyTypeEnum.SOLES) {
        bankName = paymentData.bankNameSoles.Code;
        accountNumber = paymentData.accountNumberSoles;
        accountType = paymentData.accountTypeSoles.Name;
    } else {
        bankName = paymentData.bankNameDolares.Code;
        accountNumber = paymentData.accountNumberDolares;
        accountType = paymentData.accountTypeDolares.Name;
    }

    accountNumber = leftPad(accountNumber, 16, '0');

    var developer = pos == virtualPosEnum.PAGO_WEB ? virtual.webSite.developer : virtual.app.developer;
    var integration = pos == virtualPosEnum.PAGO_WEB ? virtual.webSite.integration : virtual.app.integration;

    var HorarioComercio = {
        DiaDesde: '',
        DiaHasta: '',
        Turno1Desde: startTime || '',
        Turno1Hasta: endTime || '',
        Turno2Desde: '',
        Turno2Hasta: ''
    };

    var PlanxTransaccionId = 'CE';

    switch (pos) {
        case virtualPosEnum.PAGO_WEB:
            PlanxTransaccionId += 'DIRECT' + (Moneda === currencyTypeEnum.SOLES ? '01' : '02');
            break;
        case virtualPosEnum.PAGO_LINK:
            PlanxTransaccionId += 'PW0000' + (Moneda === currencyTypeEnum.SOLES ? '03' : '04');
            break;
        case virtualPosEnum.PAGO_APP:
            PlanxTransaccionId += 'APP000' + (Moneda === currencyTypeEnum.SOLES ? '03' : '04');
            break;
    }

    return {
        AfiliarComercio: {
            IdBO: '',
            IdTicket: '',
            IdOportunidad: '',
            IdCliente: '',
            Usuario: username,
            Password: '',
            NuevoComercio: 'false',
            MismaMoneda: '',
            CodigoComercio: '',
            RUC: rucValidation.ruc,
            Contacto: {
                TipoContacto: contactTypeEnum.REPRESENTANTE_LEGAL,
                Nombres: legalRepresentativeData.firstName,
                ApellidoPaterno: legalRepresentativeData.paternalName,
                ApellidoMaterno: legalRepresentativeData.maternalName,
                TelefonoMovil: legalRepresentativeData.cellPhone,
                Telefono: legalRepresentativeData.secondPhone,
                TipoDocumento: mapToVirtualValue('tipoDocumento', legalRepresentativeData.documentType.Code),
                NumeroDocumento: legalRepresentativeData.documentNumber,
                FechaNacimiento: '',
                CorreoElectronico: legalRepresentativeData.email
            },
            Direccion: [{
                Departamento: administrativeAddress.department.UbiDep,
                Provincia: administrativeAddress.province.UbiPro,
                Distrito: administrativeAddress.district.UbiDis,
                TipoVia: administrativeAddress.typeOfRoad.Code,
                NombreVia: administrativeAddress.nameOfRoad,
                NumeroVia: administrativeAddress.numberOfRoad,
                Referencia: administrativeAddress.reference,
                Telefono1: commercialAddress.cellPhone || '',
                Telefono2: commercialAddress.landline || '',
                TipoInteriorId: administrativeAddress.interiorType.IdInteriorType,
                NumeroInterior: administrativeAddress.interior,
                TipoDireccion: addressTypeEnum.ADMINISTRATIVE,
                HorarioComercio: HorarioComercio
            }, {
                Departamento: commercialAddress.department.UbiDep,
                Provincia: commercialAddress.province.UbiPro,
                Distrito: commercialAddress.district.UbiDis,
                TipoVia: commercialAddress.typeOfRoad.Code,
                NombreVia: commercialAddress.nameOfRoad,
                NumeroVia: commercialAddress.numberOfRoad,
                Referencia: commercialAddress.reference,
                Telefono1: commercialAddress.cellPhone || '',
                Telefono2: commercialAddress.landline || '',
                TipoInteriorId: commercialAddress.interiorType.IdInteriorType,
                NumeroInterior: commercialAddress.interior,
                TipoDireccion: addressTypeEnum.COMMERCIAL,
                HorarioComercio: HorarioComercio
            }],
            Oportunidad: {
                NombreComercial: commerceData.tradeName.replace(/\./g, ''),
                SubProducto: subProductEnum[_Object$keys(virtualPosEnum).find(function (key) {
                    return virtualPosEnum[key] === pos;
                })],
                MCCI: MCCI,
                Moneda: mapToVirtualValue('moneda', Moneda),
                Email: legalRepresentativeData.email,
                PlanxTransaccionId: PlanxTransaccionId,
                DiaVisita: '',
                HoraInicioVisita: '',
                TipoHorario: "01",
                MCCN: MCCI,
                FechaContrato: moment().format('DD/MM/YYYY'),
                BancoId: mapToVirtualValue('bancos', bankName),
                TipoCuentaId: mapToVirtualValue('tipoCuenta', accountType),
                NumCuentaBancaria: accountNumber,
                Dominio: '',
                NumCuentaBancariaOriginalCMS: accountNumber,
                Canal: settingsConfig.canal,
                DatosEntregaCantidadDispositivos: '0',
                DatosEntregaUnidadmedida: '',
                DatosEntregaFechadeentrega: '',
                DatosEntregaHoradesde: '',
                DatosEntregaHorahasta: '',
                DatosEntregaDepartamentoID: '',
                DatosEntregaProvinciaID: '',
                DatosEntregaDistritoID: '',
                DatosEntregaTipoviaID: '',
                DatosEntregaNombrevia: '',
                DatosEntregaNumerovia: '',
                DatosEntregaTipoInteriorID: '',
                DatosEntregaNumeroInterior: '',
                DatosEntregaReferencia: '',
                DatosEntregaTelefono1: '',
                DatosEntregaNombrecontacto: '',
                zformaDePago: '',
                Direcciones: {
                    DiaDesde: '',
                    DiaHasta: '',
                    Turno1Desde: '',
                    Turno1Hasta: '',
                    Turno2Desde: '',
                    Turno2Hasta: ''
                }
            },
            AdministradorPMM: {
                NombresyApellidos: virtual.user.fullname,
                CorreodeUsuario: virtual.user.email,
                TelefonodeUsuario: virtual.user.phone
            },
            DatosAPP: {
                NombreAPP: virtual.app.name,
                LinkAPP: virtual.app.link,
                Plataforma: virtual.app.platform
            },
            DatosIntegracion: {
                IntegracionFormularioPago: integration.paymentForm
            },
            Desarrollador: {
                Desarrollo: developer.developmentType,
                NombredeEmpresa: developer.company,
                NombresyApellidos: developer.fullname,
                CorreodelContacto: developer.email,
                TelefonodeContacto: developer.phone
            },
            Modalidad: {
                POSWebTiendaVirtual: '',
                URLdeDominio: ''
            },
            PaginaWeb: {
                WebPage: virtual.webSite.url
            }
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/mappers/virtual-affiliation.js
// module id = ./src/mappers/virtual-affiliation.js
// module chunks = 34